// extracted by mini-css-extract-plugin
module.exports =  {"modal":"aeuIMDGP","body":"o9jBXH9e","link":"wv8LWBSq","error":"SiF9t8O8","footer":"OB4xYqE6"};